<template>

  <div class="w-screen h-screen flex items-stretch">

    <Toast />
    <ConfirmDialog></ConfirmDialog>

    <Menu :model="items" class="w-full shrink-0 md:w-60">
      <template #start>
        <span class="inline-flex items-center gap-1 px-2 py-2">
          <span class="text-xl font-semibold">Hajcer<span class="text-primary">Admin</span></span>
        </span>
      </template>
      <template #submenulabel="{ item }">
        <span class="text-primary font-bold">{{ item.label }}</span>
      </template>
      <template #item="{ item, props }">
        <a @click="$router.push({ name: item.link })" v-ripple class="flex items-center" v-bind="props.action">
          <font-awesome-icon v-if="item.icon" :icon="item.icon" class="mr-2" />
          <span>{{ item.label }}</span>
          <Badge v-if="item.badge" class="ml-auto" :value="item.badge" />
        </a>
      </template>
      <template #end>
        <div class="px-4">
          <a @click="logOutUser" v-ripple class="flex items-center">
            <font-awesome-icon :icon="['fas', 'right-from-bracket']" class="mr-2" />
            <span>Log out</span>
          </a>
        </div>
      </template>
    </Menu>


    <div class="flex-1 py-2 px-4 grow-shrink h-full">
      <div v-if="!loaded">
        <div>
          Loading...
        </div>
      </div>
      <router-view v-else />
    </div>


  </div>

</template>

<script setup>
import { useRoute } from "vue-router";
import { ROUTE_NAMES } from "@/router";
import Toast from 'primevue/toast';
import useContentStore from "@/stores/contentStore";
import ConfirmDialog from "primevue/confirmdialog";
import { ref } from "vue";
import usePluStore from "@/stores/pluStore.js";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import storage from "@/services/Storage.service.js";
import { logOut } from "@/services/auth/Auth.js";

const route = useRoute()
const contentStore = useContentStore()
const pluStore = usePluStore()

const loaded = ref(false)
const load = async () => {
  await contentStore.loadCategories()
  await contentStore.loadProducts()
  await contentStore.loadMealExtras()
  await contentStore.loadFlyParts()
  await pluStore.loadPluItems()
  loaded.value = true
}

load()


const items = ref([
  {
    separator: true
  },
  {
    label: 'Objednávky',
    icon: ['fas', 'list-dropdown'],
    link: ROUTE_NAMES.HOME_VIEW
  },
  {
    separator: true
  },
  {
    label: 'Kategórie',
    icon: ['fas', 'list-tree'],
    link: ROUTE_NAMES.CATEGORIES_VIEW
  },
  {
    label: 'Produkty',
    icon: ['fas', 'utensils'],
    link: ROUTE_NAMES.PRODUCT_VIEW
  },
  {
    label: 'Prílohy',
    icon: ['fas', 'french-fries'],
    link: ROUTE_NAMES.MEAL_EXTRA_VIEW
  },
  {
    label: 'Doprava',
    icon: ['fas', 'truck'],
    link: ROUTE_NAMES.DELIVERY_VIEW
  },
  {
    label: 'Uživatelia',
    icon: ['fas', 'users'],
    link: ROUTE_NAMES.USERS_VIEW
  },
  {
    label: 'PLU',
    icon: ['fas', 'computer'],
    link: ROUTE_NAMES.PLU_VIEW
  },
  {
    label: 'Nastavenia',
    icon: ['fas', 'gear'],
    link: ROUTE_NAMES.SETTINGS_VIEW
  },
  {
    label: 'Texty',
    icon: ['fas', 'text'],
    link: ROUTE_NAMES.TEXTS_VIEW
  },
  {
    label: 'Lietajuci burger',
    icon: ['fas', 'burger'],
    link: ROUTE_NAMES.FLY_BURGER_VIEW
  },
  {
    label: 'Objednávky od stola',
    icon: ['fas', 'table-picnic'],
    link: ROUTE_NAMES.TABLES_VIEW
  },
  {
    separator: true
  }
]);

const logOutUser = () => {
  logOut()
}

</script>
